import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
// eslint-disable-next-line no-restricted-imports
import { deleteAlertsBulkActionType } from '../../../../../../backend/features/alerts/bulk-actions';
import { useAlertUiTranslation } from '../../../../../hooks';
import { useAlertsUrl } from '../../../../../hooks/useAlertsUrl';
import { showNotificationDialog } from '../../AlertDialog';
export const AlertActionsDraft = ({ data, onReload, onCloseDialog }) => {
    const { t } = useAlertUiTranslation();
    const alertsSentUrl = useAlertsUrl('sent');
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: t('common.delete') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    showConfirmDialog({
                        title: t('deleteDraftAlertsDialog.title', { count: 1 }),
                        content: t('deleteDraftAlertsDialog.message', { count: 1 }),
                        confirmLabel: t('common.delete'),
                        onConfirm: () => {
                            launchBulkAction({
                                type: deleteAlertsBulkActionType,
                                title: t('deleteDraftAlertsDialog.progress', { count: 1 }),
                                runSync: true,
                                params: { alertIds: [data.id] },
                                onClose: () => {
                                    onReload(true);
                                    onCloseDialog();
                                },
                            });
                        },
                    });
                } },
                React.createElement(DeleteOutlinedIcon, null))),
        React.createElement(Tooltip, { title: t('common.edit') },
            React.createElement(IconButton, { color: 'primary', onClick: () => {
                    showNotificationDialog({
                        alertId: data.id,
                        mode: 'draft',
                        dialogStep: 'wizard',
                        reviewFormHeader: t('pages.newFromTemplate.reviewAndSend'),
                        wizardHeader: t('common.editNotification'),
                        onSubmitSuccess: (_data, onClose) => {
                            onClose();
                            onCloseDialog();
                            navigationContext.navigate(() => navigate(alertsSentUrl));
                        },
                    });
                } },
                React.createElement(EditOutlinedIcon, null)))));
};
